import React from 'react';
import {WeaSearchGroup, WeaFormItem, WeaSelect, WeaInput,WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import WeaMaterialLib from './content/base/WeaMaterialLib';
import ETabWidth from './content/base/ETabWidth'

class Tab4Style extends React.Component {
    state = {
        eShareLevel: this.props.eShareLevel,
        eStyleOptions: this.props.eStyle.eStyleList.options,
        eStyleSelected: this.props.eStyle.eStyleList.selected,
        eIcon: this.props.eStyle.eIcon,
        eHeight: this.props.eStyle.eHeight,
        eSpacing: this.props.eStyle.eSpacing
    };

    constructor(props) {
        super(props);
        this.getSaveValues = this.getSaveValues.bind(this);
    }

    render() {
        const {eShareLevel, eStyleOptions, eStyleSelected, eIcon, eHeight, eSpacing} = this.state;
        const {eContent= {}} = this.props
        const disabled = !(eShareLevel == '2');
        return (
            <div className="portal-mesetting-style">
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <WeaFormItem label={getLabel(22913, '元素样式')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaSelect
                            options={
                                eStyleOptions.map((item) => {
                                    return {key: item.key, selected: false, showname: item.value};
                                })
                            }
                            value={eStyleSelected}
                            style={{width: '200px'}}
                            disabled={disabled}
                            onChange={value => {
                                this.setState({eStyleSelected: value});
                            }}
                        />
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(19492, '元素图标')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaMaterialLib value={eIcon} disabled={disabled} onChange={value => this.setState({eIcon: value})}/>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(207, '高度')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaInput value={'' + eHeight} style={{width: '50px'}} disabled={disabled} onChange={value => this.setState({eHeight: value})}/>
                        <span style={{marginLeft: '8px'}}>{getLabel(386531, '自适应高度（0）')}</span>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(15932, '间距')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <span>{getLabel(386532, '上间距：')}</span>
                        <WeaInput value={eSpacing.top} style={{width: '40px'}} disabled={disabled} onChange={value => this.setState({eSpacing: {...eSpacing, top: value}})}/>
                        <span style={{marginLeft: '8px'}}>{getLabel(386533, '右间距：')}</span>
                        <WeaInput value={eSpacing.right} style={{width: '40px'}} disabled={disabled} onChange={value => this.setState({eSpacing: {...eSpacing, right: value}})}/>
                        <span style={{marginLeft: '8px'}}>{getLabel(386534, '下间距：')}</span>
                        <WeaInput value={eSpacing.bottom} style={{width: '40px'}} disabled={disabled} onChange={value => this.setState({eSpacing: {...eSpacing, bottom: value}})}/>
                        <span style={{marginLeft: '8px'}}>{getLabel(386535, '左间距：')}</span>
                        <WeaInput value={eSpacing.left} style={{width: '40px'}} disabled={disabled} onChange={value => this.setState({eSpacing: {...eSpacing, left: value}})}/>
                    </WeaFormItem>
                    {eContent.etabwidth && eContent.methodvalue &&<ETabWidth ref="eTabWidth" tabwidth={eContent.etabwidth} methodvalue={eContent.methodvalue} disabled={disabled}/>}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        const {eContent= {}} = this.props
        if(eContent.etabwidth && eContent.methodvalue) {
            return {
                eStyleList: this.state.eStyleSelected,
                eStyleIcon: this.state.eIcon,
                eStyleHeight: this.state.eHeight,
                eStyleSpacing: this.state.eSpacing,
                eContentTabWidth: this.refs['eTabWidth'].getSaveValues(),
            };
        }else {
            return {
                eStyleList: this.state.eStyleSelected,
                eStyleIcon: this.state.eIcon,
                eStyleHeight: this.state.eHeight,
                eStyleSpacing: this.state.eSpacing,
            };
        }
    }
}

export default Tab4Style;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/Tab4Style.js